import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';

export const GroupRecordRecoveryScreen = lazyWithSuspense(
  async () => import('./GroupRecordRecovery'),
  {
    loadingState: <div />,
    exportKey: 'GroupRecordRecovery',
  },
);
